import React, { useState, useEffect } from 'react';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';
import CloseIcon from '@rsuite/icons/Close';
import {
  Input,
  InputGroup,
  Table,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Message,
  Modal,
  Col,
  useToaster,
  Form,
  FlexboxGrid,
  Container,
  SelectPicker,
  IconButton,
  CheckPicker
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';

interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    buyercode: string,
    companynm: string,
    buyernm: string,
    country: string,
    email: string,
    address: string,
    contactno: string,
    merchantnm: string,
    // Add other attributes if needed
  };
}
interface RowData1 {
  id: string; // or number, depending on your data
  attributes: {
    companynm: string;
  };
}

const country = ['USA', 'Russia', 'India', 'Pakistan', 'Australia', 'England', 'Germany',].map(
  item => ({ label: item, value: item })
);

const { Column, HeaderCell, Cell } = Table;
let buyercodeCounter = 1;
const AddBuyer = () => {
  const ip = 'http://192.168.1.23:1337';
  const toaster = useToaster();
  ////////////////  Function For 1 Start /////////////////
  
  const [company, setCompany] = useState({
    companynm: "",

  });
  // Fetch Data from API Start
  const [companydata, setCompanydata] = useState<RowData1[]>([]);
  const [editedRowIdscompany, setEditedRowIdscompany] = useState<string[]>([]);
  const [editedDatacompany, setEditedDatacompany] = useState<Record<string, Partial<RowData['attributes']>>>({});
  useEffect(() => {
    fetchData();
  }, [companydata]);
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/buyer-companies`);
    const json = await response.json();
    setCompanydata(json.data);
  };
  const handleEditRowcompany = (rowData) => {
    setEditedRowIdscompany((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedDatacompany((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url = `${ip}/api/buyer-companies`
  const submit = e => {
    if (company.companynm === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Company Name.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const formData = new FormData();
      formData.append('data', JSON.stringify(company));
      fetch(url, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData())
        .then(data => {
          console.log(data);
          // Refresh page after 2 seconds (3000 milliseconds)
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        })
        .catch(error => console.error(error))
      setCompany({
        companynm: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange = (inputName, value, index) => {
    setCompany({ ...company, [inputName]: value });
  };
  // Delete Data from API Start
  const handleDeleteRow = async (rowId) => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies/${rowId}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        // Row deletion was successful, update your local data or refresh the table
        const updatedData1 = companydata.filter((row) => row.id !== rowId);
        setCompanydata(updatedData1);
        console.log('Row deleted successfully.');
      } else {
        console.log('Failed to delete row.');
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };
  // Delete Data from API End
  const handleSaveRowcompany = async (rowId: string) => {
    try {
      const rowData = companydata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowData1 = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedDatacompany[rowId] },
      };
    
      const response = await fetch(`${ip}/api/buyer-companies/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData();
        setEditedRowIdscompany((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const handleInputChangecompany = (rowId, fieldName, value) => {
    setEditedDatacompany((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 1 End /////////////////


  ////////////////  Function For 2 Start /////////////////
  
  const [buyer, setBuyer] = useState({
    buyercode: "",
    companynm: "",
    buyernm: "",
    country: "",
    email: "",
    address: "",
    contactno: "",
    merchantnm: "",


  });
  // Fetch Data from API Start
  const [buyerdata, setBuyerdata] = useState<RowData[]>([]);
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});

  useEffect(() => {
    fetchData2();
  }, [buyerdata]);
  const fetchData2 = async () => {
    const response = await fetch(`${ip}/api/buyer-details`);
    const json = await response.json();
    setBuyerdata(json.data);

  };
  const generateNextCategoryCode = () => {
    const categoryCount = buyerdata.length;
    const nextCode = categoryCount + 1;
    return `BUYER-${nextCode.toString().padStart(3, "0")}`;
  };
  const handleEditRowbuyer = (rowData) => {
    setEditedRowIds((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedData((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url2 = `${ip}/api/buyer-details`
  const submit2 = e => {
    if (buyer.buyernm === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Buyer Name.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...buyer, buyercode: nextCategoryCode }));
      fetch(url2, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData2())
        .then(data => console.log(buyer))
        .catch(error => console.error(error))
      buyercodeCounter++;
      setBuyer({
        buyercode: "",
        companynm: "",
        buyernm: "",
        country: "",
        email: "",
        address: "",
        contactno: "",
        merchantnm: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
    handleClose3();
  };
  //  Fetch Data from API End
  const handleInputChange2 = (inputName, value, index) => {
    setBuyer({ ...buyer, [inputName]: value });
  };
  // Delete Data from API Start
  const handleDeleteRow2 = async (rowId) => {
    try {
      const response = await fetch(`${ip}/api/buyer-details/${rowId}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        // Row deletion was successful, update your local data or refresh the table
        const updatedData1 = buyerdata.filter((row) => row.id !== rowId);
        setBuyerdata(updatedData1);
        console.log('Row deleted successfully.');
      } else {
        console.log('Failed to delete row.');
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };
  // Delete Data from API End
  const handleSaveRowbuyer = async (rowId: string) => {
    try {
      const rowData = buyerdata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowData = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedData[rowId] },
      };
      
      const response = await fetch(`${ip}/api/buyer-details/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData();
        setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangebuyer = (rowId, fieldName, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 2 End /////////////////

  const [open, setOpen] = React.useState(false);
  const [size, setSize] = React.useState();
  const handleOpen = value => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => {

    setOpen(false)
  }
  const handleClose3 = () => setOpen(false);

  const [open1, setOpen1] = React.useState(false);
  const [size1, setSize1] = React.useState();
  const handleOpen1 = value => {
    setSize1(value);
    setOpen1(true);
  };
  const handleClose1 = () => setOpen1(false);

  // For Main Table Function Start

  const [companydataa, setCompanydataa] = React.useState([]);
  useEffect(() => {
    fetchData6();
  }, [companydataa]);
  const fetchData6 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.companynm,
        value: item.attributes.companynm,
      }));
      setCompanydataa(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };


  //product type data fetch start
  const [buyeerdata, setBuyeerdata] = React.useState([]);
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-details`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyercode,
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  
  //product type data fetch end
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (value) => {
    setSearchQuery(value);
  };
  const handleComapnyChange = (value) => {
    setSelectedCompany(value);
  };
  const handleBuyerChange = (value) => {
    setSelectedBuyer(value);
  };


  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar " justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start'>
              <h3 className="title">Buyer Details</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Buyer Details</Breadcrumb.Item>

              </Breadcrumb>
            </Stack>

            <Stack spacing={5}>
              <CheckPicker
                data={companydataa}
                placeholder="Company Name"
                labelKey="label"
                value={selectedCompany}
                onChange={handleComapnyChange}
                valueKey="value"
                size="xs"
                appearance="default"
                style={{ width: 200 }}
              />
              {/* <CheckPicker
                data={buyeerdata}
                placeholder="Buyer Name"
                labelKey="label"
                value={selectedBuyer}
                onChange={handleBuyerChange}
                valueKey="value"
                size="xs"
                appearance="default"
                style={{ width: 200 }}
              /> */}

              
            </Stack>
          </Stack>

          <Stack direction='column' alignItems='flex-end' spacing={24}>
            <Stack direction='row' spacing={5}>
              <Button appearance="default" active onClick={() => handleOpen1('md')}>
                Add Company
              </Button>
              <Button color="cyan" appearance="primary" onClick={() => handleOpen('md')}>
                Add Buyer
              </Button>
            </Stack>
            <Stack spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" type="text" value={searchQuery} onChange={handleSearch} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
            </Stack>

          </Stack>


        </Stack>
        <Divider className='divide' />



        <Table height={420} data={buyerdata.filter(item => {
          const productName = item.attributes.companynm.toLowerCase();
          const aliasCode = item.attributes.buyernm.toLowerCase();
          const ContNo = item.attributes.contactno.toLowerCase();

          const camponyname = item.attributes.companynm;
          const buyername = item.attributes.buyernm;
          const categoryMatch = selectedCompany.length === 0 || selectedCompany.includes(camponyname);
          const buyerMatch = selectedBuyer.length === 0 || selectedBuyer.includes(buyername);
          return (productName.includes(searchQuery.toLowerCase()) || 
          aliasCode.includes(searchQuery.toLowerCase()) || ContNo.includes(searchQuery.toLowerCase()))
          && categoryMatch &&buyerMatch;
        })}
          rowHeight={60}
          rowKey="id"
          bordered
        >
          <Column width={100}>
            <HeaderCell>Sr. No.</HeaderCell>
            <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>Company Name</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.companynm || rowData.attributes.companynm}
                onChange={(value) => handleInputChangebuyer(rowData.id, 'companynm', value)}
              />
            ) : (
              rowData.attributes.companynm
            )
          )}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>Buyer Name</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.buyernm || rowData.attributes.buyernm}
                onChange={(value) => handleInputChangebuyer(rowData.id, 'buyernm', value)}
              />
            ) : (
              rowData.attributes.buyernm
            )
          )}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>Country</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.country || rowData.attributes.country}
                onChange={(value) => handleInputChangebuyer(rowData.id, 'country', value)}
              />
            ) : (
              rowData.attributes.country
            )
          )}
            </Cell>
          </Column>

          <Column width={300}>
            <HeaderCell>Email</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.email || rowData.attributes.email}
                onChange={(value) => handleInputChangebuyer(rowData.id, 'email', value)}
              />
            ) : (
              rowData.attributes.email
            )
          )}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>Address</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.address || rowData.attributes.address}
                onChange={(value) => handleInputChangebuyer(rowData.id, 'address', value)}
              />
            ) : (
              rowData.attributes.address
            )
          )}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>Contact No.</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.contactno || rowData.attributes.contactno}
                onChange={(value) => handleInputChangebuyer(rowData.id, 'contactno', value)}
              />
            ) : (
              rowData.attributes.contactno
            )
          )}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>Merchant</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.merchantnm || rowData.attributes.merchantnm}
                onChange={(value) => handleInputChangebuyer(rowData.id, 'merchantnm', value)}
              />
            ) : (
              rowData.attributes.merchantnm
            )
          )}
            </Cell>
          </Column>

          <Column width={100} fixed="right">
            <HeaderCell>Action</HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <div>
                <IconButton
                  size="sm"
                  icon={<CheckIcon />}
                  active
                  onClick={() => handleSaveRowbuyer(rowData.id)}
                  style={{ marginRight: '10px' }}
                />
                <IconButton
                  size="sm"
                  icon={<CloseIcon />}
                  active
                  onClick={() => setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                />
              </div>
            ) : (
              <div>
                <IconButton
                  size="sm"
                  icon={<EditIcon />}
                  active
                  onClick={() => handleEditRowbuyer(rowData)}
                />
                {/* You can add a delete button as well if needed */}
              </div>
            )
          )}
            </Cell>
          </Column>
        </Table>

        {/* first modal start */}
        <Modal size={size} open={open} onClose={handleClose} backdrop="static">
          <Modal.Header>
            <Modal.Title><b>Add Buyer</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid justify="space-between">
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'10px'}}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Company Name</Form.ControlLabel>
                    <SelectPicker id="companynm"
                      name="companynm"
                      data={companydataa}
                      value={buyer && buyer.companynm ? buyer.companynm : ''}
                      onChange={value => handleInputChange2('companynm', value, 0)}
                      labelKey="label"
                      valueKey="value"
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <Input
                      placeholder="Buyer Name"
                      id="buyernm"
                      name="buyernm"
                      value={buyer && buyer.buyernm ? buyer.buyernm : ''} onChange={value => handleInputChange2('buyernm', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{marginBottom:'10px'}}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Country</Form.ControlLabel>
                    <SelectPicker
                    data={country}
                     id="country"
                      name="country"
                      block
                      value={buyer && buyer.country ? buyer.country : ''} onChange={value => handleInputChange2('country', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Email</Form.ControlLabel>
                    <Input id="email"
                      name="email"
                      value={buyer && buyer.email ? buyer.email : ''} onChange={value => handleInputChange2('email', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{marginBottom:'10px'}}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Address</Form.ControlLabel>
                    <Input id="address"
                      name="address"
                      value={buyer && buyer.address ? buyer.address : ''} onChange={value => handleInputChange2('address', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Contact No.</Form.ControlLabel>
                    <Input id="contactno"
                      name="contactno"
                      value={buyer && buyer.contactno ? buyer.contactno : ''} onChange={value => handleInputChange2('contactno', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Merchant</Form.ControlLabel>
                    <Input id="merchantnm"
                      name="merchantnm"
                      value={buyer && buyer.merchantnm ? buyer.merchantnm : ''} onChange={value => handleInputChange2('merchantnm', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent='flex-end' spacing={10}>
              <Button onClick={handleClose3} appearance="subtle" active>
                Cancel
              </Button>
              <Button onClick={submit2} appearance="primary" color='cyan'>
                Add
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        {/* first modal end */}

        {/* second modal start */}
        <Modal size={size1} open={open1} onClose={handleClose1} backdrop="static">
          <Modal.Header>
            <Modal.Title><b>Add Company</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack justifyContent='space-between'>
              <Input id="companynm"
                name="companynm"

                value={company && company.companynm ? company.companynm : ''} onChange={value => handleInputChange('companynm', value, 0)}
                onPressEnter={submit}
              />
              <Button onClick={submit} appearance='primary' color='cyan' active>Add Company</Button>
            </Stack>
            <Table data={companydata}
              height={400}
              rowHeight={60}
              rowKey="id"
            >
              <Table.Column width={100} align="center" fixed>
                <Table.HeaderCell>ID</Table.HeaderCell>
                <Table.Cell dataKey="id" />
              </Table.Column>

              <Table.Column width={300}>
                <Table.HeaderCell>Company Name</Table.HeaderCell>
                <Cell>
                {(rowData) => (
            editedRowIdscompany.includes(rowData.id) ? (
              <Input
                value={editedDatacompany[rowData.id]?.companynm || rowData.attributes.companynm}
                onChange={(value) => handleInputChangecompany(rowData.id, 'companynm', value)}
              />
            ) : (
              rowData.attributes.companynm
            )
          )}
                </Cell>
              </Table.Column>

              <Column width={100} fixed="right" flexGrow={1}>
                <HeaderCell>Action</HeaderCell>
                <Cell>
                {(rowData) => (
            editedRowIdscompany.includes(rowData.id) ? (
              <div>
                <IconButton
                  size="sm"
                  icon={<CheckIcon />}
                  active
                  onClick={() => handleSaveRowcompany(rowData.id)}
                  style={{ marginRight: '10px' }}
                />
                <IconButton
                  size="sm"
                  icon={<CloseIcon />}
                  active
                  onClick={() => setEditedRowIdscompany((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                />
              </div>
            ) : (
              <div>
                <IconButton
                  size="sm"
                  icon={<EditIcon />}
                  active
                  onClick={() => handleEditRowcompany(rowData)}
                />
                {/* You can add a delete button as well if needed */}
              </div>
            )
          )}
                </Cell>
              </Column>
            </Table>
          </Modal.Body>

        </Modal>
        {/* second modal end */}

        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
      </Container>
    </>
  );
};

export default AddBuyer;